<div>
    <button type="button" [disabled]="showAddManager?'true':null" mat-button class="addnewBtn" (click)="enable()" class="addnewbutton">Add New Manager</button>
    <form #addmanager="ngForm" *ngIf="showAddManager" class="md-input-container" >


        <div layout="row" class="layout-row">
            <mat-form-field class="mat-form-withtooltip" fxFlex="45">
                <mat-label>First Name</mat-label>
                <input matInput [(ngModel)]="first_name" maxlength="200" name="first_name" required>
            </mat-form-field>

        
            <mat-form-field class="mat-form-withtooltip" fxFlex="45">
                <mat-label>Last Name</mat-label>
                <input matInput [(ngModel)]="last_name" maxlength="200" name="last_name" required>
            </mat-form-field>

        </div>

        <div layout="row" class="layout-row">
            <mat-form-field class="mat-form-withtooltip" fxFlex="45">
                <mat-label>Email</mat-label>
                <input matInput [(ngModel)]="email" maxlength="200" name="email" required>
            </mat-form-field>
    
            <mat-form-field class="mat-form-withtooltip" fxFlex="45">
                <mat-label>Phone</mat-label>
                <input matInput [(ngModel)]="phone" maxlength="200" name="phone" required>
            </mat-form-field>

        </div>

        <div layout="row" class="layout-row">
            <mat-form-field class="mat-form-withtooltip" fxFlex="90">
                <mat-label>Job Title</mat-label>
                <input matInput [(ngModel)]="jobTitle" maxlength="250" name="jobTitle" required>
            </mat-form-field>

        </div>

        <div *ngIf="showAddManager">
            <button type="button" (click)="addManager($event)" mat-button
             [disabled]="!canProceed()"
             class="addnewbutton">Save New Manager</button>
            <button type="button" (click)="cancelManager($event)" mat-button class="ml-2" style="color: #248ae3;">Cancel</button>
        </div>
    </form>
</div>


